module.exports = __webpack_public_path__ + "static/media/437864709_1504495780132345_8496891759530389871_n (2).b9538ead.jpg";